import React from 'react';
import PropTypes from 'prop-types';
import Tile from './Tile';
import './Tiles.css';

function Tiles({ items, onTileClick, className }) {
  return (
    <div className={`grid-container ${className}`}>
      {items.map(item => (
        <Tile
          key={item.id}
          id={item.id}
          name={item.name}
          onTileClick={() => onTileClick(item)}
          imageUrl={item.imageUrl}
        />
      ))}
    </div>
  );
}

Tiles.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  onTileClick: PropTypes.func,
  className: PropTypes.string,
};

Tiles.defaultProps = {
  items: [],
  onTileClick: null,
  className: '',
};

export default Tiles;
